<template>
  <table class="table mt-0 mb-0 full-width">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">{{ $t('status.status') }}</th>
        <th scope="col" class="border-0">{{ $t('order.creationDate') }}</th>
        <th scope="col" class="border-0">{{ $t('order.modificationDate') }}</th>
        <th scope="col" class="border-0">{{ $t('users.user') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(statusItem, index) of reversedStatuses"
        :key="'status-' + index">
        <td class="align-middle">
          {{ getStatusName(statusItem.status) }}
        </td>
        <td class="align-middle">
          {{ statusItem.created_at }}
        </td>
        <td class="align-middle">
          {{ statusItem.updated_at }}
        </td>
        <td class="align-middle">
          {{ statusItem.user_name }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import ListUtils from './../../utils/ListUtils.js';
import orderStatuses from './../../data/order-statuses.js';

export default {
  name: 'order-history',
  props: [
    'statuses'
  ],
  computed: {
    reversedStatuses () {
      return JSON.parse(JSON.stringify(this.statuses)).reverse();
    }
  },
  methods: {
    getStatusName (status) {
      return ListUtils.getKeyLabel(orderStatuses[this.$i18n.locale], status);
    }
  }
}
</script>
